/**
 * A table showing past SLA NYR summary data by temp zone
 */

import React, { useMemo } from "react"
import PropTypes from "prop-types"
import Table, { TableRow, TableCell } from "@amzn/meridian/table"
import Text from "@amzn/meridian/text"
import NetworkSLATempSummaryTableRow from "./network-sla-temp-summary-table-row"
import Tooltip from "@amzn/meridian/tooltip"

const NetworkSLATempSummaryTable = props => {
    const { summaryData, visibleIndices } = props

    // Handle new data structure with warehouses and grandTotals
    const grandTotals = summaryData?.grandTotals;

    // Memoize visible data slice to avoid recalculation on every render
    const visibleSummaryData = useMemo(() => {
        const warehouses = summaryData?.warehouses || summaryData || [];
        return warehouses.slice(visibleIndices[0], visibleIndices[1])
    }, [summaryData, visibleIndices])

    return (
        <>
            <Table
                headerRows={grandTotals ? 2 : 1}
                showDividers={true}
                rowComponents={[NetworkSLATempSummaryTableRow, TableRow]}
                stickyHeaderRow={true}
                stickyHeaderColumn={false}
                showStripes={false}
                size="medium"
            >
                <TableRow >
                    <TableCell><Text><strong>Site Id</strong></Text></TableCell>
                    <TableCell><Text><strong>Temp Zone</strong></Text></TableCell>
                    <TableCell><Text><strong>Confirmed</strong></Text></TableCell>
                    <TableCell><Text><strong>Received</strong></Text></TableCell>
                    <TableCell><Text><strong>Total NYR/NYS</strong></Text></TableCell>
                    <TableCell><Text><strong>NYR/NYS Past SLA</strong></Text></TableCell>
                    <TableCell>
                        <Tooltip title="% of total NYR/NYS units that are past SLA" position="top">
                            <Text><strong>% NYR/NYS Past SLA</strong></Text>
                        </Tooltip>
                    </TableCell>
                    <TableCell>
                        <Tooltip title="% of total confirmed qty that has been stowed." position="top">
                            <Text><strong>% Received</strong></Text>
                        </Tooltip>
                    </TableCell>
                </TableRow>
                {grandTotals && (
                    <TableRow style={{ backgroundColor: '#f5f5f5', borderTop: '2px solid #ddd', borderBottom: '2px solid #ddd' }}>
                        <TableCell><Text><strong>TOTALS</strong></Text></TableCell>
                        <TableCell><Text><strong>All Zones</strong></Text></TableCell>
                        <TableCell><Text><strong>{grandTotals.totalExpected?.toLocaleString() || 0}</strong></Text></TableCell>
                        <TableCell><Text><strong>{grandTotals.totalReceived?.toLocaleString() || 0}</strong></Text></TableCell>
                        <TableCell><Text><strong>{grandTotals.totalNYR?.toLocaleString() || 0}</strong></Text></TableCell>
                        <TableCell><Text><strong>{grandTotals.totalNYRPastSLA?.toLocaleString() || 0}</strong></Text></TableCell>
                        <TableCell><Text><strong>{grandTotals.percentPastSLA}%</strong></Text></TableCell>
                        <TableCell><Text><strong>{grandTotals.percentReceived}%</strong></Text></TableCell>
                    </TableRow>
                )}
                {visibleSummaryData.map((warehouse, warehouseIndex) => (
                    <NetworkSLATempSummaryTableRow
                        key={warehouse.warehouseName}
                        summaryData={warehouse}
                    />
                ))}
            </Table>
        </>
    )
}

NetworkSLATempSummaryTable.propTypes = {
    visibleIndices: PropTypes.arrayOf(PropTypes.number).isRequired,
    summaryData: PropTypes.arrayOf(PropTypes.object).isRequired
}

export default React.memo(NetworkSLATempSummaryTable)
